// Import libraries

const AboutProject = () => {
  return (
    <div className="about-project">
      <div></div>
    </div>
  );
};

export default AboutProject;
